import { FC } from 'react';
import { Grid, Theme } from '@material-ui/core';
import { createStyles, makeStyles, styled } from '@material-ui/core/styles';

import {
  MarketoFormComponent,
  MarketoFormComponentProps,
} from '@bizapp-lp/pjr/organisms/MarketoFormComponent';
import {
  DocumentIntroduction,
  DocumentIntroductionProps,
} from '@bizapp-lp/pjr/organisms/DocumentIntroduction';
import { Footer } from '@bizapp-lp/pjr/organisms/Footer';
import { Header } from '@bizapp-lp/pjr/organisms/Header';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    articleArea: {
      padding: theme.spacing(5, 2, 8),
    },
  }),
);

export interface MarketoComplexFormProps
  extends Omit<DocumentIntroductionProps, 'children'>,
    MarketoFormComponentProps {
  article?: React.ReactNode;
}

export const MarketoComplexForm: FC<MarketoComplexFormProps> = ({
  className,
  title,
  subtitle,
  imgSrc,
  imgAlt,
  article,
  marketoForm,
  children,
}) => {
  const classes = useStyles();

  const articleProps: DocumentIntroductionProps = {
    title: title,
    subtitle: subtitle,
    imgSrc: imgSrc,
    imgAlt: imgAlt,
  };

  const FormBox = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#F2f3fb',
    padding: theme.spacing(5, 2, 7.5),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(5, 4, 7.5),
    },
  }));

  return (
    <>
      <Header />
      <Grid container className={className}>
        <Grid item xs={12} sm={6} className={classes.articleArea}>
          <DocumentIntroduction {...articleProps}>
            {article}
          </DocumentIntroduction>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormBox>
            <MarketoFormComponent marketoForm={marketoForm}>
              {children}
            </MarketoFormComponent>
          </FormBox>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default MarketoComplexForm;
